import { NgxUploaderModule } from '@angular-ex/uploader';
import { JobseekerLookupResolveService } from './shared/services/jobseeker-lookup-resolve.service';
import { SharedModule } from '../shared/shared.module';
import { JobseekersRoutingModule } from './jobseekers-routing.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JobseekerViewEditComponent } from './jobseeker-view-edit/jobseeker-view-edit.component';
import { JobseekerListComponent } from './jobseeker-list/jobseeker-list.component';
import { JobseekersShellComponent } from './jobseekers-shell/jobseekers-shell.component';
import { JobseekerService } from '@admin/jobseekers/shared/services/jobseeker.service';
import { JobseekerDetailsComponent } from './jobseeker-details/jobseeker-details.component';
import { JobseekerBasicComponent } from './jobseeker-basic/jobseeker-basic.component';
import { JobseekerWorkExperienceInfoComponent } from './jobseeker-work-experience-info/jobseeker-work-experience-info.component';
import { JobseekerEducationInfoComponent } from './jobseeker-education-info/jobseeker-education-info.component';
import { JobseekerLanguageInfoComponent } from './jobseeker-language-info/jobseeker-language-info.component';
import { WorkExperienceEditorComponent } from './work-experience-editor/work-experience-editor.component';
import { JobseekerWorkExperienceItemComponent } from './jobseeker-work-experience-item/jobseeker-work-experience-item.component';
import { JobseekerEducationItemComponent } from './jobseeker-education-item/jobseeker-education-item.component';
import { EducationEditorComponent } from './education-editor/education-editor.component';
import { JobseekerLanguageItemComponent } from './jobseeker-language-item/jobseeker-language-item.component';
import { JobseekerUploadedDocumentInfoComponent } from './jobseeker-uploaded-document-info/jobseeker-uploaded-document-info.component';
import { JobseekerUploadedDocumentItemComponent } from './jobseeker-uploaded-document-item/jobseeker-uploaded-document-item.component';
import { JobseekerSubscriptionComponent } from './jobseeker-subscription/jobseeker-subscription.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModerationJobseekerComponent } from './moderation-jobseeker/moderation-jobseeker.component';
import { JobseekerContactInfoComponent } from './moderation-jobseeker/jobseeker-contact-info/jobseeker-contact-info.component';
import { JobseekerModerationWorkExperienceComponent } from './moderation-jobseeker/jobseeker-moderation-work-experience/jobseeker-moderation-work-experience.component';
import { JobseekerModerationEducationComponent } from './moderation-jobseeker/jobseeker-moderation-education/jobseeker-moderation-education.component';
import { JobseekerModerationLanguagesComponent } from './moderation-jobseeker/jobseeker-moderation-languages/jobseeker-moderation-languages.component';
import { JobseekerModerationAttachmentComponent } from './moderation-jobseeker/jobseeker-moderation-attachment/jobseeker-moderation-attachment.component';
import { JobseekerModerationSkillsComponent } from './moderation-jobseeker/jobseeker-moderation-skills/jobseeker-moderation-skills.component';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { JobseekerModerationButtonsComponent } from './moderation-jobseeker/jobseeker-moderation-buttons/jobseeker-moderation-buttons.component';
import { JobseekerListDetailsComponent } from './jobseeker-list-details/jobseeker-list-details.component';
import { JobseekerEducationFilterComponent } from './jobseeker-education-filter/jobseeker-education-filter.component';

@NgModule({
  imports: [
    CommonModule,
    JobseekersRoutingModule,
    SharedModule,
    NgxUploaderModule,
    MultiSelectModule,
    FormsModule,
    ReactiveFormsModule,
    AngularSvgIconModule,
  ],
  exports: [JobseekerViewEditComponent],
  providers: [JobseekerService, JobseekerLookupResolveService],
  declarations: [
    JobseekerViewEditComponent,
    JobseekerListComponent,
    JobseekersShellComponent,
    JobseekerDetailsComponent,
    JobseekerBasicComponent,
    JobseekerWorkExperienceInfoComponent,
    JobseekerEducationInfoComponent,
    JobseekerLanguageInfoComponent,
    WorkExperienceEditorComponent,
    JobseekerWorkExperienceItemComponent,
    JobseekerEducationItemComponent,
    EducationEditorComponent,
    JobseekerLanguageItemComponent,
    JobseekerUploadedDocumentInfoComponent,
    JobseekerUploadedDocumentItemComponent,
    JobseekerSubscriptionComponent,
    ModerationJobseekerComponent,
    JobseekerContactInfoComponent,
    JobseekerModerationWorkExperienceComponent,
    JobseekerModerationEducationComponent,
    JobseekerModerationLanguagesComponent,
    JobseekerModerationAttachmentComponent,
    JobseekerModerationSkillsComponent,
    JobseekerListDetailsComponent,
    JobseekerModerationButtonsComponent,
    JobseekerEducationFilterComponent,
  ],
})
export class JobseekersModule {}
